/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <div class="home-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据分析</el-breadcrumb-item>

        <el-select style="margin-left: 20px;" v-model="getJZ" placeholder="选择部门" @change="handleNodeClick" size="small"
          v-if="user.username == 'admin'">
          <el-option v-for="item in deptData" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-breadcrumb>
    </div>

    <el-row :gutter="20">
      <el-col :xs="{span:'4-8'}" :sm="{span:'4-8'}" :md="{span:'4-8'}" :lg="{span:'4-8'}" :xl="{span:'4-8'}" class="fbox ">
        <div class="tItem t1">
          <img class="t-icon" src="../../assets/img/s1.png" />
          <h3 class="h-title"> 账户总余额</h3>
          <p style="color: #fff;">{{totalMoney}}<span class="unit">(元)</span></p>
        </div>
      </el-col>
      <el-col :xs="{span:'4-8'}" :sm="{span:'4-8'}" :md="{span:'4-8'}" :lg="{span:'4-8'}" :xl="{span:'4-8'}" class="fbox ">
        <div class="tItem t2">
          <img class="t-icon" src="../../assets/img/s2.png" />
          <h3 class="h-title">开户数量</h3>
          <p style="color: #fff;">{{accountNum}}<span class="unit">(个)</span></p>
        </div>
      </el-col>
      <el-col :xs="{span:'4-8'}" :sm="{span:'4-8'}" :md="{span:'4-8'}" :lg="{span:'4-8'}" :xl="{span:'4-8'}" class="fbox cc">
        <div class="tItem t3" @click="showDialog('nobind')">
          <img class="t-icon" src="../../assets/img/s3.png" />
          <h3 class="h-title"> 未开户数量</h3>
          <p style="color: #fff;">{{noAccountNnm}}<span class="unit">(个)</span></p>
        </div>
      </el-col>
      <el-col :xs="{span:'4-8'}" :sm="{span:'4-8'}" :md="{span:'4-8'}" :lg="{span:'4-8'}" :xl="{span:'4-8'}" class="fbox cc">
        <div class="tItem t4" @click="showQf">
          <img class="t-icon" src="../../assets/img/s5.png" />
          <h3 class="h-title">欠费数量</h3>
          <p style="color: #fff;">{{arrearsNum}}<span class="unit">(个)</span></p>
        </div>
      </el-col>
      <el-col :xs="{span:'4-8'}" :sm="{span:'4-8'}" :md="{span:'4-8'}" :lg="{span:'4-8'}" :xl="{span:'4-8'}" class="fbox cc">
        <div class="tItem t5" @click="showDe">
          <img class="t-icon" src="../../assets/img/s4.png" />
          <el-tooltip class="item" effect="dark" content="当前表的余额大于0低于20元" placement="left">
            <h3 class="h-title"> 低额度数量</h3>
          </el-tooltip>
          <p style="color: #fff;">{{lowQuota.num}}<span class="unit">(个)</span></p>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="9" class="">
        <div class="tbox">
          <el-row type="flex" justify="space-between" class="title-border">
            <el-col>
              <h3 class="h-title"><i class="el-icon-date"></i> 能耗日历</h3>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="16">
              <el-calendar v-model="cdate">
                <template slot="dateCell" slot-scope="{date, data}">
                  <span @click="getDate(data)">{{ data.day.substring(8)}}</span>
                </template>

              </el-calendar>
            </el-col>
            <el-col :span="8">
              <div class="riliBox">
                <div class="yl-content">
                  <el-scrollbar style="height: 100%;">
                    <ul>
                      <li v-for="item in riliData">
                        <img src="../../assets/img/power.png" v-if="item.mapKey == 15" />
                        <img src="../../assets/img/water.png" v-if="item.mapKey == 16" />
                        <h4>{{item.label}}<span class="sunit">({{ getUnit(item.mapKey) }})</span></h4>
                        <p style="color:#1485D5">{{item.data}}</p>
                      </li>
                    </ul>
                  </el-scrollbar>
                </div>

              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>

      <el-col :span="8" class="re">
        <div class="tbox">
          <el-row type="flex" justify="space-between" class="title-border">
            <el-col>
              <h3 class="h-title"><i class="el-icon-pie-chart"></i> 能耗用途统计</h3>
            </el-col>
            <el-col style="line-height: 60px;">
              <el-radio-group v-model="timeType" @change="getpay">
                <el-radio label="day">昨天</el-radio>
                <el-radio label="month">当月</el-radio>
                <el-radio label="year">当年</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="paybox">
            <p style="text-align: center;color: ddd; font-size: 14px;" v-if="noData">暂无数据</p>
            <div class="cavasbox" ref="payEchart"></div>
          </div>
          <div class="ntype">
            <el-radio-group v-model="ntype" size="mini" @change="getpay">
              <el-radio-button :label="15">电</el-radio-button>
              <el-radio-button :label="16">水</el-radio-button>
              <el-radio-button :label="18">热能</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </el-col>

      <el-col :span="7">
        <div class="tbox re">
          <h3 class="h-title title-border"><i class="el-icon-odometer"></i>设备总览统计</h3>
          <div class="meter-contet">


            <el-carousel>
              <el-carousel-item indicator-position="outside">
                <div class="outbox">
                  <div class="meterBox power">
                    <h3>电表数量</h3>
                    <p>{{powerMeteNum}} <span style="font-size:16px; position: relative;top: -5px;">（只）</span> </p>
                  </div>
                  <div class="meterBox water">
                    <h3>水表数量</h3>
                    <p>{{waterMeteNum}} <span style="font-size:16px; position: relative;top: -5px;">（只）</span> </p>
                  </div>
                  <div class="meterBox zd">
                    <h3>终端数量</h3>
                    <p>{{terCount}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                  </div>

                  <div class="meterBox zdOnline">
                    <h3>终端在线数量</h3>
                    <p>{{terOnlineCount}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                  </div>
                </div>
              </el-carousel-item>
             <!-- <el-carousel-item>
                <div class="outbox">
                  <div class="meterBox power">
                    <h3>热能表数量</h3>
                    <p>{{hotNum}}<span style="font-size:16px; position: relative;top: -5px;">（只）</span></p>
                  </div>

                </div>
              </el-carousel-item> -->

            </el-carousel>
          </div>
        </div>
      </el-col>


    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="sbox1">
          <el-row type="flex" justify="space-between" class="title-border">
            <el-col>
              <h3 class="h-title"><i class="el-icon-s-data"></i> 能耗分类</h3>
            </el-col>
            <el-col style="line-height: 60px;text-align: center;">
              <el-radio-group v-model="ftimeType" @change='getFenLei'>
                <el-radio label="month">逐日</el-radio>
                <el-radio label="year">逐月</el-radio>
              </el-radio-group>
            </el-col>

          </el-row>
          <div class="paybox">
            <div class="cavasbox" ref="fengLei"></div>
          </div>
        </div>

      </el-col>
      <el-col :span="12">
        <div class="sbox1">
          <el-row type="flex">
            <el-col>
              <h3 style="color: #F56C6C;" class="h-title"><i style="color: #F56C6C;" class="el-icon-warning"></i> 异常表数据</h3>
            </el-col>
            <el-col>
              <div style="line-height: 60px; float: right;">
                <el-radio-group v-model="unusualType" size="mini" @change="changeUnusua">
                  <el-radio-button :label="15">电</el-radio-button>
                  <el-radio-button :label="16">水</el-radio-button>
                  <el-radio-button :label="18">热能</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
          <el-table :header-cell-style="{background:'#9495FF',color:'#ffffff'}" size="small" :data="unusualData"
            v-loading="loadingUnusual" element-loading-text="加载中" style="width: 100%;" stripe height="300">
            <el-table-column align="center" type="index" width="60">
            </el-table-column>
            <el-table-column label="计量点名称" prop="name">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>


    <el-dialog :title="title" :visible.sync="editFormVisible" @click="editFormVisible = false" width="42%">
      <!-- :header-cell-style="this.$store.state.headerCss" -->
      <el-table size="small" :data="dialogData" v-loading="loading" border element-loading-text="加载中" style="width: 100%;"
        stripe height="300">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column :label="title == '未开户数据'?'租户名称':'计量点名称'" prop="name">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="欠费数据" :visible.sync="qfVisible" width="42%">
      <!-- :header-cell-style="this.$store.state.headerCss" -->

      <el-table  size="small" :data="qfRunningList" v-loading="loading" border
        element-loading-text="加载中" style="width: 100%;" stripe height="300">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>

        <el-table-column label="计量点名称" prop="meterInfoName" v-if="payType == 1">
          <template slot-scope="scope">
            <div >{{scope.row.meterInfoName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="计量点名称" v-if="payType == 2">
          <template slot-scope="scope">
            <div v-for="item in scope.row.meterList">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column label="金额(元)" sortable prop="blance">
         <!-- <template slot-scope="scope">
            <div >{{scope.row.blance}}</div>
          </template> -->
        </el-table-column>
      </el-table>
      <div style="margin-top: 14px;">总计：{{qfTotalMoney}}元</div>
    </el-dialog>
    <el-dialog title="低额度数据" :visible.sync="deVisible" width="42%">
      <!-- :header-cell-style="this.$store.state.headerCss" -->

      <el-table  size="small" :data="lowQuota.data" v-loading="loading" border
        element-loading-text="加载中" style="width: 100%;" stripe height="300">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>

        <el-table-column label="计量点名称" prop="meterInfoName" v-if="payType == 1">
          <template slot-scope="scope">
            <div >{{scope.row.meterInfoName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="计量点名称" v-if="payType == 2">
          <template slot-scope="scope">
            <div v-for="item in scope.row.meterList">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column label="金额(元)" prop="blance" sortable>
         <!-- <template slot-scope="scope">
            <div >{{scope.row.blance}}元</div>
          </template> -->
        </el-table-column>
      </el-table>
    </el-dialog>



    <!-- 能耗日历选择分类分项 -->
    <!-- <el-dialog title="选择能源分项" width="500px" :visible.sync="showEnegryFl">
      <el-form label-width="120px" >
        <el-form-item label="能源种类" >
          <el-select  placeholder="请选择" size="small"  v-model="fenLeiForm.energyType" @change="changeSub">
            <el-option v-for="item in energyTypeData" :label="item.energyTypeName" :value="item.energyTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="能源分项" >
          <el-select  placeholder="选择能源分项" size="small" v-model="fenLeiForm.energyDataItemId">
            <el-option label="无分项" value="" v-if="energyTypeData.length"></el-option>
            <el-option v-for="item in subTypeData" :label="item.energyDataName" :key="item.id" :value="item.energyDataId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='showEnegryFl = false'>取消</el-button>
        <el-button size="small" type="primary" @click="getFenLei()">确认</el-button>
      </div>
    </el-dialog> -->


  </div>
</template>
<script>
  import Chart from 'echarts'
  import 'echarts/theme/macarons.js'
  import {
    getDeps,
    findEnergyDay,
    findEnergyYtList,
    findEnergyBranchList,
    countMoney,
    getMeterInfoData,
    getQfRunning,
    getQFMeterInfoByDepartmentId,
    getUnusual,
    getAllMeter,
    getTerminalCount,
    findPayTypeById
  } from '../../api/dataMG.js'
  import {
    getDepartmentTerminalInfoLis,
    getEnegySubItem
  } from '../../api/energyMG'
  import {
    timestampToTime
  } from '../../utils/util'
  import RowBox from "@/components/rowBox";
  export default {
    name: "welcome",
    data() {
      return {
        deVisible:false,
        qfVisible: false,
        showEnegrySub: false,
        showEnegryFl: false,
        yl: 1,
        machineNo: '',
        loading: false,
        type: 'day',
        riliData: [],
        title: '',
        date: "",
        qfTotalMoney:0,
        editFormVisible: false,
        dialogData: [],
        unpriceTables: [],
        cdate: new Date() - 24 * 60 * 60 * 1000,
        dataDate: '',
        etype: 15,
        ntype: 15,
        unusualType: 15,
        waterMeteNum: 0,
        powerMeteNum: 0,
        deptData: [],
        energyTypeData: [],
        noData: false,
        subTypeData: [],
        user: {},
        loadingUnusual: false,
        getJZ: "",
        dayData: "",
        monthDate: "",
        departmentId: "",
        timeType: "month",
        ftimeType: "month",
        waringList: [{
          name: '用电异常',
          data: [],
        }],
        payType:1,
        hotNum: 0,
        riliFrom: {
          date: "",
          departmentId: '',
        },
        fenLeiForm: {
          timeType: "",
          departmentId: '',

        },
        totalMoney: 0, //充值总金额
        accountNum: 0, //开户数量
        noAccountNnm: 0, //未开户数量
        noAccountList: [], //未开户数据

        arrearsNum: 0, //欠费数量
        qfRunningList: [], //欠费数据
        lowQuota: {
          num: 0,
          data: []
        }, //低额度数据
        unPowerData: [],
        unWaterData: [],
        unHotdata: [],
        unusualData: [],
        iconImg: "",
        terCount: 0, //终端数量
        terOnlineCount: 0

      }
    },
    // 导入组件
    components: {
      RowBox
    },

    created() {

    },
    // 挂载结束状态(里面是操作)
    mounted() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.date = timestampToTime(new Date() - 24 * 60 * 60 * 1000).substring(0, 10)
      if (this.user.username == 'admin') {
        this.getJZ = this.user.departmentName
        this.getJzData().then(res => {
          this.departmentId = res[0].id
          this.getpay()
          this.getDataByDate()
          this.getFenLei();
          this.getTotalMoney()
          this.getMeterNums();
          this.getArrearsNum();
          this.getLowQuota();
          this.getUnusualData();
          this.getData()
          this.getZdData() //获取终端数量
          this.getPayType()
        });
      } else {
        this.departmentId = this.user.departmentId
        this.getDataByDate()
        this.getFenLei();
        this.getpay();
        this.getTotalMoney()
        this.getMeterNums();
        this.getArrearsNum();
        this.getLowQuota();
        this.getUnusualData();
        this.getData()
        this.getZdData()
        this.getPayType()
      }





      this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
        let minBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
        let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
        prevBtn.addEventListener('click', () => {
          this.date = timestampToTime(this.cdate).substring(0, 10)
          this.getDataByDate()
        })
        minBtn.addEventListener('click', () => {
          this.date = timestampToTime(this.cdate).substring(0, 10)
          this.getDataByDate()
        })

        nextBtn.addEventListener('click', () => {
          this.date = timestampToTime(this.cdate).substring(0, 10)
          this.getDataByDate()
        })
      })
    },
    // 里面的函数只有调用才会执行
    methods: {


      showQf() {
        this.qfVisible = true

      },

      showDe(){
        this.deVisible = true
      },

      //根据部门获取能源分项
      getEnergySubItemByDid() {
        return new Promise((resolve, reject) => {
          let param = {
            departmentId: this.departmentId
          }
          getEnegySubItem(param).then(res => {
            if (res.status == 1) {
              this.energyTypeData = res.data
              if (this.energyTypeData.length) {
                if (this.energyTypeData.length) {
                  this.fenLeiForm.energyType = this.energyTypeData[0].energyTypeId
                  this.riliFrom.energyType = this.energyTypeData[0].energyTypeId
                  this.changeSub(this.energyTypeData[0].energyTypeId)
                }
              } else {

              }
              resolve(res.data)
            }


          })
        })

      },


      getPayType(){
        let param = {
          deptId: this.departmentId
        }
        findPayTypeById(param).then(res => {
          if (res.status == 1) {
            this.payType = res.data

          }
        })
      },

      getZdData() {
        let param = {
          departmentId: this.departmentId
        }
        getTerminalCount(param).then(res => {
          if (res.status == 1) {
            this.terCount = res.data.terCount
            this.terOnlineCount = res.data.terOnlineCount
          }
        })
      },

      getUnit(key) {
        if (key == '15') {
          return 'kWh'
        } else if (key == '16' || key == '18') {
          return 'm³'
        } else {
          return ''
        }
      },

      getIcon(key) {
        if (key == '15') {
          return '../../assets/img/power.png'
        } else if (key == '16') {
          return '../../assets/img/water.png'
        } else {
          return ''
        }
      },

      handelSub() {
        this.showEnegrySub = true
      },
      handelFl() {
        this.showEnegryFl = true
      },

      changeSub(e) {
        this.subTypeData = []
        this.fenLeiForm.energyDataItemId = ''
        this.riliFrom.energyDataItemId = ''
        this.subTypeData = this.energyTypeData.filter(item => item.energyTypeId == e)[0].DepartmentEnergyData
      },
      changeUnusua(e) {

        if (this.unusualType == 15) {
          this.unusualData = this.unPowerData
        } else if (this.unusualType == 16) {
          this.unusualData = this.unWaterData
        } else if (this.unusualType == 18) {
          this.unusualData = this.unHotdata
        }
      },

      //获取充值总金额
      getTotalMoney() {
        countMoney({
          departmentId: this.departmentId
        }).then(res => {
          if (res.status == 1) {
            this.totalMoney = res.data
          } else {
            this.$message.error('获取充值总金额失败' + res.msg)
          }
        })
      },

      getMeterNums() {
        getMeterInfoData({
          departmentId: this.departmentId
        }).then(res => {
          if (res.status == 1) {
            this.accountNum = res.data.countBdingMeterInfo
            this.noAccountNnm = res.data.countNotBdMeterInfo
            this.noAccountList = res.data.notBdMeterInfoList.map(item => {
              return {
                name: item
              }
            })
          }
        })
      },


      //获取欠费数据
      getArrearsNum() {
        getQfRunning({
          departmentId: this.departmentId
        }).then(res => {
          if (res.status == 1) {

            this.arrearsNum = res.data.countQfRunning
            this.qfRunningList = res.data.qfRunningList
            this.qfTotalMoney = res.data.qfTotalMoney
          }
        })
      },
      //获取低额度
      getLowQuota() {
        getQFMeterInfoByDepartmentId({
          departmentId: this.departmentId
        }).then(res => {
          if (res.status == 1) {
            this.lowQuota.num = res.data.countMeterInfo
            this.lowQuota.data = res.data.meterInfos

          }
        })
      },

      //获取异常表数据
      getUnusualData() {
        let param = {
          departmentId: this.departmentId
        }
        this.loadingUnusual = true
        getUnusual(param).then(res => {
          this.loadingUnusual = false
          if (res.status == 1) {
            this.unPowerData = res.data.power.map(item => {
              return {
                name: item
              }
            })
            this.unWaterData = res.data.water.map(item => {
              return {
                name: item
              }
            })
            this.unHotdata = res.data.hot.map(item => {
              return {
                name: item
              }
            })

            this.unusualData = this.unPowerData
          }
        })

      },


      //能耗用途统计
      getpay() {
        let param = {
          timeType: this.timeType,
          departmentId: this.departmentId,
          energyType: this.ntype
        }
        findEnergyYtList(param).then(res => {
          if (res.status == 1) {
            let lenData = []
            this.noData = res.data.length == 0 ? true : false
            res.data.forEach(item => {
              lenData.push(item.name)
            })
            let option = {
              tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                orient: 'vertical',
                x: 'left',
                data: lenData
              },
              toolbox: {
                show: true,
                feature: {
                  mark: {
                    show: true
                  },
                  magicType: {
                    show: true,
                    type: ['pie', 'funnel'],
                    option: {
                      funnel: {
                        x: '25%',
                        width: '50%',
                        funnelAlign: 'left',
                        max: 1548
                      }
                    }
                  },
                }
              },
              calculable: true,
              series: [{
                name: '能耗用途统计',
                type: 'pie',
                radius: '55%',

                center: ['50%', '50%'],
                data: res.data,
                label: {
                  normal: {
                    show: true,
                    formatter: "{b}\n({d}%)"
                  }
                }
              }]
            }
            this.chart = Chart.init(this.$refs.payEchart, 'macarons')
            this.chart.setOption(option)
          }


        })
      },


      //能耗分类统计
      getFenLei() {
        //findEnergyBranchList

        let dateStr = ''
        if (this.ftimeType == 'month') {
          dateStr = timestampToTime(new Date()).substring(0, 4)
        } else if (this.ftimeType == 'day') {
          dateStr = timestampToTime(new Date()).substring(0, 7)
        } else {
          dateStr = timestampToTime(new Date()).substring(0, 10)
        }


        this.fenLeiForm.timeType = this.ftimeType
        // this.fenLeiForm.date = dateStr
        this.fenLeiForm.departmentId = this.departmentId
        findEnergyBranchList(this.fenLeiForm).then(res => {
          this.showEnegryFl = false
          if (res.status == 1) {
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['电力（千瓦时）', '水（立方米）', '热能（立方米）'],
              },
              toolbox: {
                show: true,
                feature: {
                  mark: {
                    show: true
                  },
                  dataView: {
                    show: true,
                    readOnly: false
                  },
                  magicType: {
                    show: true,
                    type: ['line', 'bar']
                  },
                  restore: {
                    show: true
                  },
                  saveAsImage: {
                    show: true
                  }
                }
              },
              calculable: true,
              xAxis: [{
                type: 'category',
                data: res.data.dayList
              }],
              yAxis: [{
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#2ec7c9'
                    }
                  }
                },
                {
                  //第二条Y轴
                  type: 'value',
                  splitNumber: 5,
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#b6a2de'
                    }
                  }

                }
              ],
              series: [{
                  name: '电力（千瓦时）',
                  type: 'bar',
                  data: res.data['15'],

                  markPoint: {
                    data: [{
                        type: 'max',
                        name: '最大值'
                      },
                      {
                        type: 'min',
                        name: '最小值'
                      }
                    ],

                  },
                  // markLine: {
                  // 	data: [{
                  // 		type: 'average',
                  // 		name: '平均值'
                  // 	}]
                  // }
                },
                {
                  name: '水（立方米）',
                  type: 'bar',
                  yAxisIndex: '1',

                  data: res.data['16'],
                  markPoint: {
                    data: [{
                        type: 'max',
                        name: '最大值'
                      },
                      {
                        type: 'min',
                        name: '最小值'
                      }
                    ],

                  },

                },
                {
                  name: '热能（立方米）',
                  type: 'bar',
                  data: res.data['18'],

                  markPoint: {
                    data: [{
                        type: 'max',
                        name: '最大值'
                      },
                      {
                        type: 'min',
                        name: '最小值'
                      }
                    ],

                  },

                },
              ]
            }
            this.chart = Chart.init(this.$refs.fengLei, 'macarons')
            this.chart.setOption(option)

          }
        })
      },

      //能耗日历
      getDataByDate() {
        this.riliFrom.date = this.date
        this.riliFrom.departmentId = this.departmentId

        findEnergyDay(this.riliFrom).then(res => {
          if (res.status == 1) {
            this.riliData = res.data
            this.showEnegrySub = false
          }
        })
      },

      handleNodeClick(e) {

        this.departmentId = e
        this.getPayType()
        this.getDataByDate()
        this.getFenLei();
        this.getpay();
        this.getTotalMoney()
        this.getMeterNums();
        this.getArrearsNum();
        this.getLowQuota();
        this.getUnusualData();
        this.getData()
        this.getZdData()
        this.unusualType = 15

      },

      showDialog(type) {

        this.editFormVisible = true
        if (type == 'nobind') {
          this.title = '未开户数据'

          this.dialogData = this.noAccountList


        } else if (type == 'qf') {
          this.title = '欠费数据'
          this.dialogData = this.qfRunningList

        } else if (type == 'de') {
          this.title = '低额度数据'
          this.dialogData = this.lowQuota.data

        }
      },

      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDeps({
            accountType: 2
          }).then(res => {
            if (res.status == 1) {
              let arr = []
              this.deptData = res.data
              this.getJZ = res.data[0].departmentName
              resolve(res.data)
            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },


      getDate(val) {
        this.date = val.day
        this.getDataByDate()
      },
      getData() {
        this.loading = true
        this.powerMeteNum = 0
        this.waterMeteNum = 0
        this.hotNum = 0

        getAllMeter({
          departmentId: this.departmentId
        }).then(res => {
          this.loading = false
          if (res.status == 1) {
            res.data.forEach(item => {
              if (item.energyType == '15') {
                this.powerMeteNum = item.count
              } else if (item.energyType == '16') {
                this.waterMeteNum = item.count
              } else {
                this.hotNum = item.count
              }
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('获取数据失败，请稍后再试！')
        })
      }
    }
  };
</script>
<style>
  .el-carousel__arrow {
    opacity: 0;
  }

  .el-carousel__indicators--horizontal {
    bottom: 6px;

  }

  .el-carousel__button {
    background: rgb(121, 187, 255);
  }

  .yl-content {
    padding: 30px 5px 0 10px;
    height: 260px;
  }

  .yl-content .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .yl-content ul {
    margin: 0;
    padding: 0;

  }

  .yl-content li {
    list-style: none;
    padding-left: 30px;
    padding-bottom: 16px;
    position: relative;
    border-bottom: 1px solid #ccc;
  }

  .yl-content li img {
    position: absolute;
    left: 0;
    top: 15px;
    width: 18px;
    height: 18px;
  }

  .yl-content h4 {
    font-size: 14px;
    margin: 0;
    line-height: 50px;
  }

  .yl-content p {
    font-size: 24px;
    margin: 0;
  }

  .home-header {
    background: #fff;
    line-height: 65px;
    margin-bottom: 20px;
    padding-left: 20px;
  }

  .home-header .el-breadcrumb {
    line-height: 65px;
  }

  .meter-contet {
    width: 312px;
    overflow: hidden;
    position: absolute;
    padding-top: 20px;
    left: 50%;
    transform: translate(-50%, 0)
  }

  .outbox {
    width: 470px;
  }

  .meterBox {
    float: left;
    text-align: center;
    width: 140px;
    height: 120px;
    margin: 10px;
    color: #fff;
    overflow: hidden;
  }

  .stbox {
    margin: 0;
    margin: -10px;
    min-height: 100%;
    padding: 10px 10px 50px 10px;
    box-sizing: border-box;
    background: #ebebeb;
  }


  .meterBox h3 {
    font-weight: normal;
    font-size: 18px;
    margin: 0;
    margin-top: 20px;
    line-height: 40px;
  }

  .meterBox p {
    font-size: 24px;
    margin: 0;
  }

  .meterBox.water {
    background: url('../../assets/img/w_bg.png');
    background-size: 100% 100%;
  }

  .meterBox.power {
    background: url('../../assets/img/p_bg.png');
    background-size: 100% 100%;
  }

  .meterBox.zd {
    background: url('../../assets/img/zd.png');
    background-size: 100% 100%;
  }

  .meterBox.zdOnline {
    background: url('../../assets/img/zdon.png');
    background-size: 100% 100%;
  }

  .rili-radio {
    text-align: center;
    padding-top: 20px;
    width: 100%;
  }

  .sbox1 .data-list {
    font-size: 14px;
    line-height: 30px;
    height: 300px;
  }

  .tbox .data-list {
    overflow-y: auto;
    font-size: 14px;
    line-height: 30px;
    height: 300px;

  }

  .el-calendar-table .el-calendar-day {
    height: 30px;
  }

  .el-backtop,
  .el-calendar-table td.is-today {
    background: #ccc;
    color: #FFFFFF;
  }

  .el-calendar-table td.is-selected {
    background: #409EFF;
    color: #FFFFFF;
  }

  .re {
    position: relative;
  }

  .el-calendar-table td .el-calendar-day:hover {
    background: #409EFF !important;
    color: #FFFFFF;

  }

  .h-title {
    color: #fff;
    line-height: 60px;
    margin: 0;
    font-size: 24px;
    text-align: center;
    font-weight: normal;
    margin-top: 20px;
  }

  .tbox .h-title {

    color: #2F308D;
    text-align: left;
    line-height: 60px;
    margin: 0;
    padding-top: 0;
    padding-left: 22px;
  }

  .sbox1 .h-title {
    color: #2F308D;
    line-height: 60px;
    margin: 0;
    text-align: left;
    font-size: 24px;
    font-weight: normal;
  }

  .title-border {
    border-bottom: 1px solid #E5E5E5;
  }

  .fbox p {
    font-size: 20px;
    transition: 0.2s;
    text-align: center;
    margin: 0;
  }

  .tj-title {
    line-height: 60px;
    color: #666;
    font-size: 14px;
    text-align: right;
  }

  .tbox {

    background: #fff;
    height: 380px;
    overflow: hidden;
    margin-top: 20px;
    border-radius: 4px;
  }

  .fbox {
    height: 150px;
    overflow: hidden;
    transition: 0.4s;
    padding: 0;
    margin: 0;
    position: relative;

  }

  .tItem {
    height: 100%;
    cursor: pointer;
    margin: 0;
    transition: 0.4s;
    padding: 0;
    overflow: hidden;
    position: relative;
  }

  .tItem .t-icon {
    position: absolute;
    right: 20px;
    top: 10px;
  }

  .tItem.t1 {
    background: url(../../assets/img/t1.png);
    background-size: 100% 100%;
  }

  .tItem.t2 {
    background: url(../../assets/img/t2.png);
    background-size: 100% 100%;
  }

  .tItem.t3 {
    background: url(../../assets/img/t3.png);
    background-size: 100% 100%;
  }

  .tItem.t4 {
    background: url(../../assets/img/t4.png);
    background-size: 100% 100%;
  }

  .tItem.t5 {
    background: url(../../assets/img/t5.png);
    background-size: 100% 100%;
  }

  .fbox.cc:hover {
    background: #f4f4f4;

  }

  .fbox:hover p {
    transform: scale(1.2);
  }

  .sunit {
    font-size: 12px;
    padding: 0 4px;
    color: #3A8EE6;
  }


  .sbox1 {
    margin-top: 20px;
    background: #fff;
    height: 380px;
    overflow: hidden;
    border-radius: 8px;
    padding: 0 20px;
  }

  .el-calendar-day {
    position: relative;
  }

  .el-calendar-day span {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: center;
    padding-top: 6px;
  }


  .box-card {
    margin-bottom: 14px;
  }

  .ntype {
    position: absolute;
    bottom: 20px;
    left: 20px;
  }

  .el-col-xl-4-8 {
    width: 20%;
  }

  .el-col-lg-4-8 {
    width: 20%;
  }

  .el-col-md-4-8 {
    width: 20%;
  }

  .el-col-sm-4-8 {
    width: 20%;
  }

  .el-col-xs-4-8 {
    width: 20%;
  }

  .el-calendar__body {
    padding: 12px 10px
  }

  .el-calendar__header {
    padding: 10px;
  }


  .stbgc {
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
    padding: 0px 16px;
  }

  .stsearch {
    text-align: center;
  }

  .text-c {
    text-align: center;
  }

  .st-gbox {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 5px;
    height: 30vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .paybox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    overflow: hidden;
    height: 32vh;
  }

  .el-calendar__title {
    font-size: 14px;
  }

  .el-calendar-table {
    font-size: 14px;
  }

  .unit {
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    top: -2px;
  }

 /* .el-card__header {
    padding: 14px 20px;

  } */

/*  .zl-item {
    color: #fff;
    padding: 20px;
    height: 112px;
    margin-bottom: 4px;
  }

  .zl-item span {
    font-size: 14px;
  }

  .zl-item p {
    font-size: 28px;
  } */

/*  .el-card__body {
    padding: 14px 20px;
    	color: #F56C6C;
    font-weight: bold;
    font-size: 20px;
  } */

  .utitle {
    font-weight: bold;
  }

  .udata-list {
    margin-bottom: 10px;
    line-height: 30px;
    font-size: 14px;
  }

  /* .zl-item.scale:hover {} */



  @media screen and (max-width: 1800px) {
    .el-calendar__title {}

    .el-calendar__header {}

    .el-radio {
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 1600px) {

    .h-title,
    .sbox1 .h-title {
      font-size: 18px;
      font-weight: bold;
    }

    .yl-content {
      padding: 30px 2px;
    }

    .yl-content h4 {
      font-size: 12px;
      white-space: nowrap;
    }

    .yl-content p {
      font-size: 20px;
      white-space: nowrap;
    }

    .tItem .t-icon {
      width: 26px;
      right: 10px;
    }

    .el-calendar__button-group .el-button--mini {
      padding: 7px 10px
    }

  }

  @media screen and (max-width: 1400px) {
    .fbox {
      height: 120px;
    }

    .meterBox {
      width: 130px;
      height: 110px;
    }

    .outbox {
      width: 448px;
    }

    .meter-contet {
      width: 297px;
    }

    .yl-content li {
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue